import axios from '../../axios/index.js'

export default{
    list(data){
        return axios.get('vendors/list')
    },
    show(id){
        return axios.get(`vendors/show/${id}`)
    },
    moduleList(data){
        return axios.get('vendors/module/list', { params: data })
    },
    store(data){
        return axios.post('vendors/store',data)
    },
    storeEmail(data){
        return axios.post('vendors/store-email',data)
    },
    deleteEmail(data){
        return axios.post('vendors/delete-email',data)
    },
    storePayday(data){
        return axios.post('vendors/store-payday',data)
    },
    editPayday(data){
        return axios.post('vendors/edit-payday',data)
    },
    deletePayday(data){
        return axios.post('vendors/delete-payday',data)
    },
    getTypes(){
        return axios.get('vendors/getTypes')
    },
    add(data){
        return axios.post('vendors/add',data)
    },
    search(data) {
        return axios.get('vendors/search', { params: data })
    },
}
